import { whatsappNumber } from '../clients/phone'

// whatsappLink builds the deep link ADR-018 settled on: wa.me, the number in
// E.164 without its +, and the drafted message as the text parameter.
//
// Tapping it opens her own WhatsApp with the words already there and she
// presses send. That is not a limitation worked around — it is what makes
// ADR-007's "AI never sends" structural rather than a policy, because there is
// no code path here that transmits anything.
//
// The number goes through whatsappNumber: a client typed in as 07700 900123
// is stored that way, and wa.me needs the country code in place of the 0.
export function whatsappLink(phone: string, message: string): string {
  return `https://wa.me/${whatsappNumber(phone)}?text=${encodeURIComponent(message)}`
}
